import {apiFetch} from '../_helpers';


export const loyaltyCampaingsService = {
    getAll,
};


function getAll() {
    return apiFetch("loyaltycampaings/");
}